/**
 * Presentation block parallax effect
 * Slides the background logo from off-screen right towards the center of the block
 * as the user scrolls. The logo reaches its final position when the block is fully visible.
 */
const presentationParallax = () => {
  const block = document.querySelector(".presentation-block");
  if (!block) return;

  const logo = block.querySelector(".presentation-bg-logo");
  if (!logo) return;

  let ticking = false;

  const update = () => {
    const rect = block.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    // progress: 0 when block enters viewport from below, 1 when fully visible
    const progress = Math.min(Math.max((viewportHeight - rect.top) / (viewportHeight + rect.height), 0), 1);

    // Slide from right: starts at right:-60% (CSS), capped at 40% of block width
    const blockWidth = block.offsetWidth;
    const translateX = Math.max(-(progress * blockWidth * 0.7), -(blockWidth * 0.35));
    const rotate = -5 + progress * 10;

    logo.style.transform = `translateY(-50%) translateX(${translateX}px) rotate(${rotate}deg)`;
    ticking = false;
  };

  window.addEventListener("scroll", () => {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });

  // Run once on load in case block is already in view
  requestAnimationFrame(update);
};

presentationParallax();

export default presentationParallax;
